<link href="//fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700" rel="stylesheet">
<link href="//fonts.googleapis.com/css?family=Playfair+Display:400,400i,700,700i,900" rel="stylesheet">
<app-menu *ngIf="!auth.isAuthenticated()"></app-menu><div *ngIf="!auth.isAuthenticated()"><br><br><br><br></div>

<div id="map-mapbox"></div>
<pre id="coordinates" class="coordinates"></pre>
<div id="phone-filter" class="container p-5 bg-white">
  <div class="d-flex justify-content-center flex-column-reverse">
    <div class="row">
      <div class="col-md-4">
        <select [(ngModel)]="filters.status" name="type" (change)="getAnnouncesByFilters()" class="selectpicker" data-style="btn btn-primary btn-round text-white" title="Status Select">
          <option value="Location">{{'rent' | translate}}</option>
          <option value="Vente">{{'sale' | translate}}</option>
        </select>
      </div>
      <div class="col-md-4">
        <select [(ngModel)]="filters.type" name="type" (change)="getAnnouncesByFilters()" class="selectpicker" data-style="btn btn-success btn-round text-white" title="Type Select">
          <option value="Maison">{{'house' | translate}}</option>
          <option value="Appartement">{{'apartment' | translate}}</option>
          <option value="Terrain">{{'lot' | translate}}</option>
          <option value="Café">{{'cafe' | translate}}</option>
          <option value="Garage">{{'garage' | translate}}</option>
          <option value="Usine">{{'factory.' | translate}}</option>
          <option value="Immeuble">{{'building' | translate}}</option>
          <option value="Maison de village">{{'village house' | translate}}</option>
        </select>
      </div>
      <div class="col-md-4">
        <select [(ngModel)]="filters.city" name="type" (change)="getAnnouncesByFilters()" class="selectpicker" data-style="btn btn-danger btn-round text-white" title="City Select">
          <option *ngFor="let city of cities" [value]="city">{{city}}</option>
        </select>
      </div>
    </div>
  </div>
  <br><br>
  <div class="d-flex justify-content-center flex-column">
    <div class="row">
      <div class="col-md-6">
        <h6 class="text-primary">{{'keyword' | translate }}</h6>
        <input [(ngModel)]="filters.keyword" (keyup)="getAnnouncesByFilters()" name="status" type="text"
               class="form form-control"
               placeholder="{{'placeholder' | translate }}"
        />
      </div>
      <div class="col-md-4">
        <h6 class="text-primary">Surface (m2)</h6>
        <input class="form-control" type="text" name="" [(ngModel)]="filters.surface" (change)="getAnnouncesByFilters()">
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-4">
        <h6 class="text-primary">Budget min</h6>
        <input class="form-control" min="1" type="number" name="" [(ngModel)]="filters.budget_min"
               (change)="getAnnouncesByFilters()">
      </div>
      <div class="col-md-4">
        <h6 class="text-primary">Budget max</h6>
        <input class="form-control" min="1" type="number" name="" [(ngModel)]="filters.budget_max"
               (change)="getAnnouncesByFilters()">
      </div>
    </div>
  </div>
</div>
<div id="floating-panel" (mouseover)="liteToggleFilter(true)" (mouseleave)="liteToggleFilter(false)">
  <div class="d-flex justify-content-center flex-column-reverse">
    <div class="row">
      <div class="col-md-4">
        <select [(ngModel)]="filters.status" name="type" (change)="getAnnouncesByFilters()" class="selectpicker" data-style="btn btn-primary btn-round text-white" title="Status Select">
          <option value="Location">{{'rent' | translate}}</option>
          <option value="Vente">{{'sale' | translate}}</option>
        </select>
      </div>
      <div class="col-md-4">
        <select [(ngModel)]="filters.type" name="type" (change)="getAnnouncesByFilters()" class="selectpicker" data-style="btn btn-primary btn-round text-white" title="Type Select">
          <option value="Maison">{{'house' | translate}}</option>
          <option value="Appartement">{{'apartment' | translate}}</option>
          <option value="Terrain">{{'lot' | translate}}</option>
          <option value="Café">{{'cafe' | translate}}</option>
          <option value="Garage">{{'garage' | translate}}</option>
          <option value="Usine">{{'factory.' | translate}}</option>
          <option value="Immeuble">{{'building' | translate}}</option>
          <option value="Maison de village">{{'village house' | translate}}</option>
        </select>
      </div>
      <div class="col-md-4">
        <select [(ngModel)]="filters.city" name="type" (change)="getAnnouncesByFilters()" class="selectpicker" data-style="btn btn-primary btn-round text-white" title="City Select">
          <option *ngFor="let city of cities" [value]="city">{{city}}</option>
        </select>
      </div>
    </div>
  </div>
  <br><br>
  <div class="d-flex justify-content-center flex-column">
    <div class="row">
      <div class="col-md-6">
        <h6 class="text-primary">{{'keyword' | translate }}</h6>
        <input [(ngModel)]="filters.keyword" (keyup)="getAnnouncesByFilters()" name="status" type="text"
               class="form form-control"
               placeholder="{{'placeholder' | translate }}"
        />
      </div>
      <div class="col-md-4">
        <h6 class="text-primary">Surface (m2)</h6>
        <input class="form-control" type="text" name="" [(ngModel)]="filters.surface" (change)="getAnnouncesByFilters()">
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-md-4">
        <h6 class="text-primary">Budget min</h6>
        <input class="form-control" min="1" type="number" name="" [(ngModel)]="filters.budget_min"
               (change)="getAnnouncesByFilters()">
      </div>
      <div class="col-md-4">
        <h6 class="text-primary">Budget max</h6>
        <input class="form-control" min="1" type="number" name="" [(ngModel)]="filters.budget_max"
               (change)="getAnnouncesByFilters()">
      </div>
    </div>
  </div>
</div>
<div id="filter-trigger" (click)="toggleFilter()" (mouseover)="liteToggleFilter(true)" (mouseleave)="liteToggleFilter(false)" class="bg-white"><i class="material-icons">filter_alt</i></div>


